import React,{useContext} from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
//import clsx from 'clsx';
import {
  AppBar, 
  Toolbar, 
  MenuItem, 
  ListItemText, 
  Button,
  Typography,
  Link,
  ListItemIcon,
  Divider,
  Grid,
  Avatar,
  IconButton,
} from '@mui/material';
import BrandingStatsCan from '../Headers/BrandingStatsCan';
import Language from '../Headers/Language';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from './Menu';
import Icon from '@mdi/react';
import {mdiHelpCircle, mdiMenuDown, mdiOpenInNew} from '@mdi/js';
import {
  DialogFormGetSupportFab,
  DialogGetSupportFab,
} from './DialogBox';

import {UserInfoContext} from '../../StateObjects/UserInfoContext';
import {ProjectInfoContext} from '../../StateObjects/ProjectInfoContext';
import {Auth} from '../../Api/auth';
import {useTranslation} from 'react-i18next';
import {UserRole} from '../../ApplicationConfig/constants';
import { useHistory } from "react-router-dom";
import {SM_SCREEN} from '../../Theme/constants';
import Alert from './Alert';
import Snackbar from './Snackbar';

import { useMsal } from "@azure/msal-react";

const PREFIX = 'Header';

const classes = {
  stickyHeader: `${PREFIX}-stickyHeader`,
  appBar: `${PREFIX}-appBar`,
  statisticsCanadaLogoHeight: `${PREFIX}-statisticsCanadaLogoHeight`,
  verticalDividerHeight: `${PREFIX}-verticalDividerHeight`,
  branding: `${PREFIX}-branding`,
  lang: `${PREFIX}-lang`,
  verticalDivider: `${PREFIX}-verticalDivider`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  position: 'sticky',
  top: 0,
  zIndex: 1200,

  [`& .${classes.appBar}`]: {
    backgroundColor: theme.palette.common.white,
    zIndex: 1100,
  },

  [`& .${classes.statisticsCanadaLogoHeight}`]: {
    height: theme.spacing(3),
    maxWidth: '100%',
  },

  [`& .${classes.verticalDividerHeight}`]: {
    height: theme.spacing(5),
  },

  [`& .${classes.branding}`]: {
    [theme.breakpoints.down('md')]: {
      flexGrow: 1,
    },
    '& img': {
      height: theme.spacing(3),
    },
  },

  [`& .${classes.lang}`]: {
    paddingLeft: theme.spacing(1),
  },

  [`& .${classes.verticalDivider}`]: {
    margin: theme.spacing(2),
  }
}));

function ShowMenuButton(props) {
  const urlArray=window.location.pathname.split('/')
  const hashVar = urlArray[urlArray.length-1]
  const {t} = useTranslation();

  if (hashVar === 'home' || props.enableAllPages) {
    return (
      <IconButton
        onClick={props.clickHandler}
        sx={{mr: 1}}
        edge="start"
        aria-label={props.open ? t("site.header.hideProjectList") : t("site.header.showProjectList")}
        size="large">
        <MenuIcon />
      </IconButton>
    );
  } else {
    return <></>;
  }
}

export default function DefaultHeader(props) {
  const { instance } = useMsal();
  
  const {userInfo} = useContext(UserInfoContext);
  const {t, i18n} = useTranslation();
  const history = useHistory();
  
  let userInitialsArray=userInfo.fullName.split(' ')
  let userInitials="NA"

  if (userInitialsArray.length==2){
    userInitials=userInitialsArray[0].substring(0,1) + userInitialsArray[1].substring(0,1)
  }

  const [state, setState] = React.useState({
    windowWidth: window.innerWidth,
  });

  const [open, setOpen] = React.useState({
    dialogSupportFab: false,
    dialogFormSupport: false,
    alert: JSON.parse(window.sessionStorage.getItem('alert') || true),
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElHelp, setAnchorElHelp] = React.useState(null);
  const [snackbarState, setSnackbarState] = React.useState({
    open: false,
    severity: "success",
    message: ""
  });

  const {projectInfo,setProjectInfo} = React.useContext(ProjectInfoContext);

  const isSmScreen = state.windowWidth < SM_SCREEN;

  const handleClickOpen = (state) => {
    setOpen({...open, [state]: true});
  };

  const handleClickClose = (state) => {
    setOpen({...open, [state]: false});
  };
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  /* const handleClickHelp = (event) => {
    setAnchorElHelp(event.currentTarget);
  }; */

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseHelp = () => {
    setAnchorElHelp(null);
  };

  const handleDismissAlert=()=>{
    window.sessionStorage.setItem('alert', JSON.stringify(false));
    setOpen({...open, alert:false});
  }

  const handleBlur=(event)=>{
    if (event.key === 'Tab') {
      event.preventDefault();
      setAnchorEl(null);
    }
  }

  /* const handleBlurHelp=(event)=>{
    if (event.key === 'Tab') {
      event.preventDefault();
      setAnchorElHelp(null);
    }
  } */

 
  const logoutHandler=()=>{



    Auth.authorizedFetch("/logout",{},instance)
    .then(res => res.json())
    .then((result) => {
      if (result.statusCode==200){

        const activeAccount = instance.getActiveAccount();
        
        instance.logoutRedirect({account:activeAccount}).catch(e => {
          console.error(e);
        });
        
        Auth.logout();

        
      }
    })
    .catch((e)=>{
      console.log(e)
      setSnackbarState({open: true, severity: "error", message: "Error happened while logging out. Please try again."});
    })
  }

  React.useEffect(() => {
    // Detect screen size
    const handleResize = () =>
      setState({...state, windowWidth: window.innerWidth});
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [state]);

  const returnAdmin=()=>{
    const requestOptions = {
      method: 'POST',
      headers: {'Content-Type': 'application/json'}
    };

    Auth.authorizedFetch("/api/updateToAdmin", requestOptions,instance)
    .then(res=>{
      if(res.ok){
        setProjectInfo({'id':-1})
        sessionStorage.clear();
        history.push("/"+i18n.language+"/home");
        history.go(0);
      }else if(res.status===404){
        setSnackbarState({open: true, severity: "error", message: "You do not have an account for that role"});
      }else{
        setSnackbarState({open: true, severity: "error", message: "An error has occured"});
      }
    })
    .catch((error)=>{
      console.error("OH NOS, SOMETHING BAD HAPPENED", error);
      setSnackbarState({open: true, severity: "error", message: "An error has occured"});
    });
  }

  const updateRole=(newRole)=>{
    const requestOptions = {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({"newRole": newRole})
    };
    Auth.authorizedFetch("/api/updateAdminRole", requestOptions,instance)
    .then(res=>{
      if(res.ok){
        setProjectInfo({'id':-1})
        sessionStorage.clear();

        history.push("/"+i18n.language+"/home");
        history.go(0);
      }else if(res.status===404){
        setSnackbarState({open: true, severity: "error", message: "You do not have an account for that role"});
      }else{
        setSnackbarState({open: true, severity: "error", message: "An error has occured"});
      }
    })
    .catch((error)=>{
      console.error("OH NOS, SOMETHING BAD HAPPENED", error);
      setSnackbarState({open: true, severity: "error", message: "An error has occured"});
    });
  }

  const menuItemSignOut = () => {
    return (
      <MenuItem key="1" onClick={() => logoutHandler()}>
        <ListItemText
          primary={<Typography variant="body2">{t('site.header.logout')}</Typography>}
        />
      </MenuItem>
    );
  };

  const menuItemHandbook = () => {
    const ref = React.createRef();
    return (
      <MenuItem
        onClick={() => {
          handleCloseHelp();
          ref.current.click();
        }}
        key="2"
      >
        <Link ref={ref} href="#" target="_blank" underline="hover">
          <ListItemText
            primary={
              <Typography variant="body2">
                {t('site.header.vettingHandbook')}
              </Typography>
            }
          />
          <ListItemIcon>
            <Icon path={mdiOpenInNew} size={1} sx={{ml: 1}} />
            <span className="screen-reader-text">{t('site.header.opensNewTab')}</span>
          </ListItemIcon>
        </Link>
      </MenuItem>
    );
  };

  const menuItemDocumentation = () => {
    const ref = React.createRef();
    return (
      <MenuItem
        divider
        onClick={() => {
          handleCloseHelp();
          ref.current.click();
        }}
        key="3"
      >
        <Link ref={ref} href="#" target="_blank" underline="hover">
          <ListItemText
            primary={
              <Typography variant="body2">
                {t('site.header.trainingDoc')}
              </Typography>
            }
          />
          <ListItemIcon>
            <Icon path={mdiOpenInNew} size={1} sx={{ml: 1}} />
            <span className="screen-reader-text">{t('site.header.opensNewTab')}</span>
          </ListItemIcon>
        </Link>
      </MenuItem>
    );
  };

  const menuItemsSupport = () => {
    if(!props.source || !props.handleSupportSubmit){
      return null;
    }

    return (
      <MenuItem
        onClick={
          props.source === 'dashboard' ?
            () => {
              handleClickOpen('dialogSupportFab');
              handleCloseHelp();
            } :
            () => {
              handleClickOpen('dialogFormSupport');
              handleCloseHelp();
            }
        }
        key="5"
      >
        <ListItemText
          primary={<Typography variant="body2">{t('site.header.getSupport')}</Typography>}
        />
      </MenuItem>
    );
  };

  /* const menuItems = () => {
    return [
      menuItemHandbook(),
      menuItemDocumentation(),
      menuItemsSupport(),
    ];
  }; */

  React.useEffect(() => {
    // Detect screen size
    const handleResize = () =>
      setState({...state, windowWidth: window.innerWidth});
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [state]);
  
  return (
    <Root>
      <AppBar className={classes.appBar} position="sticky">
        <Alert 
          severity="info"
          role="note"
          message={t("site.header.betaAlert")}
          handleClose={handleDismissAlert}
          open={open.alert}
          banner
        />
        <Toolbar>
          <Grid container>
            <Grid item sm={12} md>
              <Toolbar sx={{p:0}}>
                <ShowMenuButton 
                  enableAllPages={props.enableMenuAllPages ? props.enableMenuAllPages : false} 
                  clickHandler={props.clickHandler}
                  open={props.open}
                />
                <div className={classes.statisticsCanadaLogoHeight}>
                  <BrandingStatsCan 
                    handleSaveBeforeLeave={props.handleSaveBeforeLeave}
                  />
                </div>
                <Divider
                  orientation="vertical"
                  className={classes.verticalDivider}
                  flexItem
                />
                <Typography variant="body2" component="h1" color="textPrimary">
                  {t("site.header.title")}
                </Typography>
              </Toolbar>
            </Grid>
            {userInfo.adminAccount && userInfo.role===UserRole.Researcher &&
              <Grid item>
                <Toolbar sx={{p:0}}>
                  <Button id="switchTo-admin-btn" variant="outlined" onClick={returnAdmin}>Return to Admin</Button>
                  <Button id="switchTo-analyst-btn" variant="outlined" color="primary" onClick={()=>updateRole(UserRole.Analyst)}>Switch to Analyst</Button>
                </Toolbar>
              </Grid>
            }
            {userInfo.adminAccount && userInfo.role===UserRole.Analyst &&
              <Grid item>
                <Toolbar sx={{p:0}}>
                  <Button id="switchTo-researcher-btn" variant="outlined" color="primary" onClick={()=>updateRole(UserRole.Researcher)}>Switch to Researcher</Button>
                  <Button id="switchTo-admin-btn" variant="outlined" onClick={returnAdmin}>Return to Admin</Button>
                </Toolbar>
              </Grid>
            }
            {userInfo.role===UserRole.Admin &&
              <Grid item>
                <Toolbar sx={{p:0}}>
                  <Button id="switchTo-researcher-btn" variant="outlined" color="primary" onClick={()=>updateRole(UserRole.Researcher)}>Switch to Researcher</Button>
                  <Button id="switchTo-analyst-btn" variant="outlined" color="primary" onClick={()=>updateRole(UserRole.Analyst)}>Switch to Analyst</Button>
                </Toolbar>
              </Grid>
            }
            <Grid item>
              <Toolbar sx={{p:0}}>
                {/* Commented out for now. Planned for later release
                <nav>
                  <Button
                    color="default"
                    aria-controls="menu-help"
                    aria-haspopup="true"
                    onClick={handleClickHelp}
                    startIcon={<Icon path={mdiHelpCircle} size={1} />}
                    endIcon={<Icon path={mdiMenuDown} size={1} />}
                    sx={{mr: 1}}
                    className={clsx({
                      'edge-start': isSmScreen,
                    })}
                  >
                    {t("site.header.help")}
                  </Button>
                  <Menu 
                    id="menu-help"
                    anchorEl={anchorElHelp}
                    keepMounted
                    open={Boolean(anchorElHelp)}
                    handleClose={handleCloseHelp}
                    handleBlur={handleBlurHelp}
                    content={menuItems()}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                    transformOrigin={{vertical: 'top', horizontal: 'center'}}
                  />
                </nav>*/}
                <Divider
                  orientation="vertical"
                  sx={{mr: 1}}
                  className={classes.verticalDividerHeight}
                />
                <Language />
                <IconButton
                  aria-controls="avatar-button-menu"
                  aria-haspopup="true"
                  aria-label={t("site.header.accountMenu")}
                  onClick={handleClick}
                  size="large">
                  <Avatar className="avatar-purple" component="span">
                    {userInitials}
                  </Avatar>
                </IconButton>
                <Menu
                  id="avatar-button-menu"
                  open={Boolean(anchorEl)}
                  anchorEl={anchorEl}
                  content={[menuItemSignOut()]}
                  handleClose={handleClose}
                  handleBlur={handleBlur}
                />
              </Toolbar>
              </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      {props.children}
      {props.handleSupportSubmit &&
        <>
          <DialogGetSupportFab
            toggleDialog={() => handleClickClose('dialogSupportFab')}
            open={open.dialogSupportFab}
            handleSupportSubmit={props.handleSupportSubmit}
          />
          <DialogFormGetSupportFab
            toggleDialog={() => handleClickClose('dialogFormSupport')}
            open={open.dialogFormSupport}
            handleSupportSubmit={props.handleSupportSubmit}
          />
        </>
      }
      <Snackbar 
        message={snackbarState.message}
        severity={snackbarState.severity}
        open={snackbarState.open}
        handleClose={()=>{setSnackbarState({...snackbarState, open: false, message: ""})}}
      />
    </Root>
  );
}
DefaultHeader.propTypes={
  enableMenuAllPages: PropTypes.bool,
  clickHandler: PropTypes.func,
  handleSaveBeforeLeave: PropTypes.func,
  source: PropTypes.oneOf(["dashboard", "form"]),
  handleSupportSubmit: PropTypes.func,
  open: PropTypes.bool,
  children: PropTypes.node,
}